module.exports = __webpack_public_path__ + "img/Slice 269@2x.c9a7e4b4.png";